import React from 'react';

import { StepProps } from '@betterment/js-runtime';
import { useFeatureFlag } from '@betterment/shared-components';

import { CustomerSignupValues } from './Controller';
import EmploymentForm from './EmploymentForm';
import LegacyOccupation from './LegacyOccupation';

import FullPageLoader from '../Shared/components/FullPageLoader';
import { CheckingSignupData, CheckingSignupDataParams } from '../Shared/data';

export const CHECKING_FLOW_UPDATES_FLAG = 'retail.checking_account_flow_updates_q1_2026_enabled';

export interface Props extends StepProps<CustomerSignupValues> {
  checkingSignupData: CheckingSignupData;
  handleClose: () => void;
  persistCheckingSignupData: (values: CheckingSignupDataParams) => Promise<void>;
}

const Occupation: React.FC<React.PropsWithChildren<Props>> = ({
  checkingSignupData,
  handleClose,
  persistCheckingSignupData,
  ...stepProps
}) => {
  const { enabled: isNewFlowEnabled, loading: isCheckingFlowUpdatesLoading } = useFeatureFlag({
    splitName: CHECKING_FLOW_UPDATES_FLAG,
    context: 'checking_signup',
  });

  if (isCheckingFlowUpdatesLoading) {
    return <FullPageLoader />;
  }

  if (!isNewFlowEnabled) {
    return (
      <LegacyOccupation
        {...stepProps}
        initialRole={stepProps.flowState.values.role ?? ''}
        roleOptions={checkingSignupData.roleOptions}
        handleClose={handleClose}
      />
    );
  }

  return (
    <EmploymentForm
      {...stepProps}
      checkingSignupData={checkingSignupData}
      handleClose={handleClose}
      persistCheckingSignupData={persistCheckingSignupData}
    />
  );
};

export default Occupation;
